import { http } from './http'
import { Pagination, PaginationParams } from './map'
import {
  Artist,
  ArtistDetails,
  ArtistPayload,
  ArtistPerformance,
  ArtistPerformanceResponse,
  PerfArtistPayload,
  PerformancePaginationParams,
} from '../../common/models'

export interface ArtistParams extends PaginationParams {
  name?: string | null
}

export const getAllArtists = (params?: ArtistParams) =>
  http.get<Pagination<Artist>>('/operations/artists', {
    params,
  })

export const createArtist = (data: ArtistPayload) =>
  http.post<Artist>('/operations/artists', data)

export const updateArtist = (id: string, data: ArtistPayload) =>
  http.put<ArtistDetails>(`/operations/artists/${id}`, data)

export const unpublishArtist = (ids: string[]) =>
  http.put('/operations/artists/unpublish', {
    ids,
  })

export const publishArtist = (ids: string[]) =>
  http.put('/operations/artists/publish', {
    ids,
  })

export const deleteArtist = (ids: string[]) =>
  http.delete('/operations/artists', {
    data: {
      ids,
    },
  })

export const getArtist = (id: string) =>
  http.get<ArtistDetails>(`/operations/artists/${id}`)

export const getAllPerformances = (params?: PerformancePaginationParams) =>
  http.get<Pagination<ArtistPerformance>>('/operations/artist-performances', {
    params,
  })

export const createPerformance = (data: PerfArtistPayload) =>
  http.post<ArtistPerformanceResponse>('/operations/artist-performances', data)

export const updatePerformance = (id: string, data: PerfArtistPayload) =>
  http.put<ArtistPerformanceResponse>(
    `/operations/artist-performances/${id}`,
    data,
  )

export const deletePerformance = (ids: string[]) =>
  http.delete('/operations/artist-performances', {
    data: {
      ids,
    },
  })

export const getPerformance = (id: string) =>
  http.get<ArtistPerformanceResponse>(`/operations/artist-performances/${id}`)
